import styled from '@emotion/styled';
import rcCollapse from 'rc-collapse';
import stopwatchIcon from '@chronos/assets/svg/stopwatch.svg';

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  overflow-y: auto;

  -webkit-overflow-scrolling: touch;
  -webkit-transform: translateZ(0);

  ::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  ::-webkit-scrollbar-button:end:increment,
  ::-webkit-scrollbar-button:start:decrement {
    background: #0000;
    display: none;
  }

  ::-webkit-scrollbar-track-piece {
    background: #091e4214;
  }

  ::-webkit-scrollbar-track-piece:vertical:start {
    border-radius: 4px 4px 0 0;
  }

  ::-webkit-scrollbar-track-piece:vertical:end {
    border-radius: 0 0 4px 4px;
  }

  ::-webkit-scrollbar-track-piece:horizontal:start {
    border-radius: 4px 0 0 4px;
  }

  ::-webkit-scrollbar-track-piece:horizontal:end {
    border-radius: 0 4px 4px 0;
  }

  ::-webkit-scrollbar-thumb:horizontal,
  ::-webkit-scrollbar-thumb:vertical {
    background: #091e4221;
    border-radius: 4px;
    display: block;
    height: 48px;
  }
`;

export const Collapse = styled(rcCollapse)`
  background: transparent;
  border: none;
  color: yellow;
`;

export const Panel = styled(rcCollapse.Panel)`
  border-top: none !important;
  color: red;

  margin-top: 10px;
  // background-color: #ebecf0;
  background-color: ${({ theme }) => (theme.dark ? '#101204' : '#ebecf0')};
  border-radius: 4px;

  &:last-child {
    margin-bottom: 25px;
  }

  .rc-collapse-content {
    background: transparent;
    border: none;
    padding: 0 6px;
  }
  .rc-collapse-content-box {
    margin: 0;
  }
`;

export const CardsList = styled.div``;
export const CardsListItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
  margin: 10px 0;
  padding: 10px;
  background-color: ${({ theme }) =>
    theme.dark ? '#282e32' : theme.bgColors.primary};
  line-height: 22px;
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 20%) 1px 1px 4px 0;
`;

export const ListItemStats = styled.div`
  display: flex;
  gap: 2px;
  white-space: nowrap;
  min-height: 22px;
`;

export const ListItemStatsIcon = styled.div`
  height: 18px;
  width: 18px;
  background-size: cover;
  background-image: url(${stopwatchIcon});
  filter: brightness(0) invert(46%) sepia(9%) saturate(928%) hue-rotate(180deg)
    brightness(97%) contrast(86%);
`;

export const ListItemStatsText = styled.div`
  font-size: 12px;
  color: #666;
`;

export const WhoisTrackingText = styled.div`
  font-size: 12px;
  color: #666;
`;

export const CardName = styled.span`
  color: rgb(24, 144, 255);
  cursor: pointer;
`;
